import axios from "axios";
import interceptors from "@/shared/api/interceptors";
import store from "@/shared/store";
window.domain = window.__CONFIG__.VUE_APP_BASE_DOMAIN;

const apiClient2 = axios.create({
  baseURL: window.__CONFIG__.VUE_APP_BASE_DOMAIN + "/tg",
  withCredentials: true,
});

store.commit("SET_DOMAIN", window.__CONFIG__.VUE_APP_BASE_DOMAIN);

interceptors(apiClient2);

export default apiClient2;
